import {
  LogoClaudeColored,
  LogoGeminiColored,
  LogoOpenaiColored,
} from "components/icons/generated";
import { IconComponent } from "types/Icon";

export const SPACELIFT_DEFAULT_LABEL = "Spacelift default";

export const PROVIDER_ICON_MAP: Record<string, IconComponent> = {
  Anthropic: LogoClaudeColored,
  Bedrock: LogoClaudeColored,
  Google: LogoGeminiColored,
  OpenAI: LogoOpenaiColored,
};
